// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3pPLe","footer":"ModalInfo_footer__3-oXl"};